/**
 * About this Sanitisation:
 * https://desygner.atlassian.net/wiki/spaces/EDIT/pages/2520351251/Data+Bounding+and+Data+Box+Coordinates
 */

import {
  getDimensionsFromElement
} from 'assets/js/editor/utils/dimensions';

export function setDataBoxCoordinates (element, dimensions) {
  const { x, y, width, height } = dimensions;

  element.dataset.boxCoordinates = [x, y, width, height].join(' ');
}

export function setDataBounding (element, dimensions) {
  const { x, y, width, height } = dimensions;

  element.dataset.boundingX = x;
  element.dataset.boundingY = y;
  element.dataset.boundingWidth = width;
  element.dataset.boundingHeight = height;
}

export function getClipPathId (element) {
  const clipPathAttribute = element.hasAttribute('clip-path')
    ? element.getAttribute('clip-path')
    : element.querySelector('[clip-path]')?.getAttribute('clip-path');

  if (!clipPathAttribute) return;

  return INKIVE.EditorFacade.editor.canvas.getClipPathId(clipPathAttribute);
}

export function sanitizeDimensionAttributes (element) {
  if (!element.hasAttribute('clip-path') || !element.hasAttribute('custom-placeholder')) return;

  const clipPath = document.querySelector(getClipPathId(element));

  clipPath && setDataBoxCoordinates(element, getDimensionsFromElement(clipPath));
  setDataBounding(element, getDimensionsFromElement(element));
}
